module.exports = __webpack_public_path__ + "static/assets/410013221be3eaaac5abdb0273c1a842.png";